export const CODES_TAG_TYPE = 'Codes';
